import { Icon, Layout, Menu } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import { DefaultAuthState } from '../../core-module/models/redux/DefaultAuthState';
import { hasRole } from '../../core-module/helpers/RoleHelper';
import { SideBarItem } from '../../../types';
import { DefaultAppState } from '../../core-module/models/redux/DefaultAppState';
import { collapseSidebar } from '../../core-module/redux/App/actions';

const { Sider } = Layout;

interface SideBarProps {
  options: Array<SideBarItem>;
  urlPrefix: string;
  nextUrlPrefix: string;
  auth: DefaultAuthState;
  app: DefaultAppState;
  dispatch: Dispatch;
}

interface State {
  init: boolean;
}

class SideBar extends React.Component<SideBarProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      init: false
    };

    this.doCollapseSidebar = this.doCollapseSidebar.bind(this);
  }

  componentDidMount() {
    this.setState({ init: true });
  }

  doCollapseSidebar(e) {
    if (this.state.init) {
      this.props.dispatch(collapseSidebar({ collapseSidebar: e }));
    }
  }

  render() {
    const { urlPrefix, nextUrlPrefix, options, auth } = this.props;
    const matchingUrls = options
      .filter((item) =>
        item.exact
          ? window.location.pathname === `/${urlPrefix}/${item.url}`
          : window.location.pathname.includes(item.url)
      )
      .map((item) => `/${urlPrefix}/${item.url}`);

    return (
      <Sider
        onCollapse={this.doCollapseSidebar}
        collapsible={true}
        collapsed={this.props.app.collapseSidebar}
        breakpoint={'lg'}
        style={{ backgroundColor: '#2D353C' }}
      >
        <Menu
          theme={'dark'}
          mode={'inline'}
          defaultSelectedKeys={matchingUrls}
          style={{ backgroundColor: '#2D353C' }}
        >
          {options.map((item, index) => {
            if (
              auth.roles &&
              ((item.role && !hasRole(auth.roles, item.role)) ||
                auth.roles.some((role) => item.excludeRoles.indexOf(role) > -1))
            ) {
              return undefined;
            }

            const url = item.next ? `/${nextUrlPrefix}/${item.url}` : `/${urlPrefix}/${item.url}`;
            return (
              <Menu.Item key={url}>
                {item.next && (
                  <a
                    href={url}
                    style={{
                      textDecoration: 'none',
                      color: 'rgba(255, 255, 255, 0.8)'
                    }}
                  >
                    <Icon type={item.icon} />
                    <span className='nav-text'>{item.label}</span>
                  </a>
                )}
                {!item.next && (
                  <Link
                    to={url}
                    style={{
                      textDecoration: 'none',
                      color: 'rgba(255, 255, 255, 0.8)'
                    }}
                  >
                    <Icon type={item.icon} />
                    <span className='nav-text'>{item.label}</span>
                  </Link>
                )}
              </Menu.Item>
            );
          })}
        </Menu>
      </Sider>
    );
  }
}

const mapPropsToDispatch = ({ auth, app }) => ({ auth, app });

export default connect(mapPropsToDispatch)(SideBar);
